import { render, staticRenderFns } from "./AccidentDetail.vue?vue&type=template&id=d491271c&scoped=true"
import script from "./AccidentDetail.vue?vue&type=script&lang=js"
export * from "./AccidentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d491271c",
  null
  
)

export default component.exports